import { render } from "./ExternalParties.vue?vue&type=template&id=0e920b4e&scoped=true"
import script from "./ExternalParties.vue?vue&type=script&lang=js"
export * from "./ExternalParties.vue?vue&type=script&lang=js"

import "./ExternalParties.vue?vue&type=style&index=0&id=0e920b4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e920b4e"]])

export default __exports__